export const ROUTE_PATHS = {
  ONLINE: '/online',
  WORKSHOP_OVERVIEW: '/workshop-overview',
  DASHBOARD: '/dashboard',
  READINGS: '/readings',
  WATER_READINGS: '/water-readings',
  GAS_READINGS: '/gas-readings',
  HEAT_READINGS: '/heat-readings',
  WASTE_READINGS: '/waste-readings',
  SANKEY: '/sankey',
  ALARMS: '/alarms',
  HISTORICAL_ODOMETERS: '/historical-odometers',
  ALARMS_HISTORY: '/alarms-history',
  LOGIN: '/login',
  REGISTER: '/register',
  HOME: '/',
  PROFILE: '/profile',
  ENERGY: '/energy',
  ENERGY_DASHBOARD: '/energy-dashboard',
  ELECTRICITY: '/electricity',
  WATER: '/water',
  GAS: '/gas',
  HEAT: '/heat',
  WASTE: '/waste',
  ENVIRONMENT: '/environment',
  SETTINGS: '/settings',
  BRANCH_OFFICES: '/branch-offices',
  WORKSHOPS: '/workshops',
  CENTERS: '/centers',
  GROUPS: '/groups',
  ODOMETERS: '/odometers',
  POWER_FACTOR: '/power-factor',
  POWER_FACTORS: '/power-factors',
  READING_DETAIL: '/energy/electricity/readings/:id',
  WATER_READING_DETAIL: '/energy/water/readings/:id',
  GAS_READING_DETAIL: '/energy/gas/readings/:id',
  HEAT_READING_DETAIL: '/energy/heat/readings/:id',
  WASTE_READING_DETAIL: '/energy/waste/readings/:id',
  ODOMETER_DETAIL: '/energy/electricity/historical-odometers/:id',
  ODOMETER_EDIT: '/odometers/:id/edit',
  ODOMETER_CREATE: '/odometers/create',
  USERS: '/users',
  FILTERS: '/filters',
  SANITIZERS: '/sanitizers',
  PROCESSOR_CONFIGS: '/processor-configs',
  FORGOT_PASSWORD: '/forgot-password',
  CHANGE_PASSWORD: '/change-password',
};